<template>
  <div>
    <div style="margin: 12px 0; color: #ee822f; font-size: 14px"></div>
    <div style="margin: 12px 0; color: #ee822f; font-size: 14px">
      *班主任老师您好，以下是经过心理测评筛查出来咱们班有异常的同学名单，希望班主任多进行关注引导。如果与我们的评测观察有额外的信息，请班主任记录。
    </div>
    <TableList
      :columns="tabPaneConfig[tabKey - 1].columns"
      :tableData="tabPaneConfig[tabKey - 1].tableData"
      :loading="tabPaneConfig[tabKey - 1].loading"
      :scroll="false"
      :pagination="tabPaneConfig[tabKey - 1].pagination"
      @change="handleTableChange"
    >
      <div slot="queryArea" class="query-area">
        <div>
          <a-select
            placeholder="请选择量表"
            v-model="queryParam.evaluationId"
            style="width: 170px; margin-right: 15px"
            :options="evaluationOptions"
          />
          <a-input-search
            v-model="queryParam.name"
            placeholder="请输入学生名字"
            class="search-space"
            style="width: 170px"
            @change="searchName"
          />
          <a-button type="primary" @click="queryTable">查询</a-button>
        </div>
        <div>
          <a-button
            type="primary"
            icon="download"
            style="margin-right: 15px"
            @click="handleExportXls('学生评估记录')"
          >
            导出
          </a-button>
        </div>
      </div>
      <template slot="action" slot-scope="{ record }">
        <div class="action-detail">
          <span @click="iknowAction(record)" :style="{ opacity: record.knowStatus == 1 && 0.5 }">
            我已知晓
          </span>
          <a-divider type="vertical" />
          <span @click="addCommunicatRecord(record, 'view')">评估记录</span>
        </div>
      </template>
    </TableList>
    <AssessmentRecord ref="assessmentRecordRef" @refreshData="loadData" />
  </div>
</template>
<script>
import TableList from '@comp/chart/TableList.vue'
import { getAction, putAction } from '@api/manage'
import { simpleDebounce } from '@/utils/util'
import AssessModal from '@/comUi/AssessModal.vue'
import AssessmentRecord from './components/AssessmentRecord.vue'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

const tablePagination = {
  current: 1,
  pageSize: 10,
  pageSizeOptions: ['10', '50', '100'],
  showTotal: (total, range) => {
    return range[0] + '-' + range[1] + ' 共' + total + '条'
  },
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
}

export default {
  name: 'ClassMoodDetail',
  components: {
    TableList,
    AssessModal,
    AssessmentRecord,
  },
  mixins: [JeecgListMixin],
  props: {
    viewRecord: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tabKey: 1,
      queryParam: {},
      dateRange: [],
      tabPaneConfig: [
        {
          tab: '',
          key: 1,
          columns: [
            {
              title: '序号',
              dataIndex: 'index',
              align: 'center',
            },
            {
              title: '班级',
              dataIndex: 'className',
              align: 'center',
            },
            {
              title: '学生',
              dataIndex: 'studentName',
              align: 'center',
            },
            {
              title: '测评计划',
              dataIndex: 'planName',
              align: 'center',
            },
            {
              title: '测评完成时间',
              dataIndex: 'finishTime',
              align: 'center',
            },
            {
              title: '家庭情况',
              dataIndex: 'classReflect_dictText',
              align: 'center',
            },
            {
              title: '家庭表现',
              dataIndex: 'familyCondition_dictText',
              align: 'center',
            },
            {
              title: '备注',
              dataIndex: 'remarks',
              align: 'center',
            },
            // {
            //   title: '评估时间',
            //   dataIndex: 'remarks',
            //   align: 'center',
            // },
            {
              title: '操作',
              dataIndex: 'action',
              align: 'center',
              scopedSlots: { customRender: 'action' },
            },
          ],
          tableData: [],
          loading: false,
          pagination: { ...tablePagination },
        },
      ],
      url: {
        list: '/studentRecord/unEvaluate',
        exportXlsUrl: '/studentRecord/unEvaluateExport',
      },
      detailModalData: [],
      evaluationOptions: [],
      disableMixinCreated: true,
    }
  },
  created() {
    if (!this.viewRecord.id) return
    this.$set(this.queryParam, 'planId', this.viewRecord.id)
    this.getEvaluationByPlanId()
  },
  methods: {
    onRangeChange() {},
    // 分页变化
    handleTableChange(page) {
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'pagination', page)
      this.loadData()
    },
    // 查询
    queryTable() {
      console.log('查询条件--', this.queryParam)
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'pagination', { ...tablePagination })
      this.loadData()
    },
    searchName: simpleDebounce(function (event) {
      console.log('搜索条件--', event.target.value)
      const name = event.target.value
      this.getTableData()
    }, 500),
    loadData() {
      switch (this.tabKey) {
        case 1:
          this.$set(this.url, 'list', '/studentRecord/unEvaluate')
          break
      }
      this.getTableData()
    },
    async getEvaluationByPlanId() {
      const res = await getAction('/schoolEvaluationPlan/getEvaluationByPlanId', {
        planId: this.viewRecord.id,
      })
      if (res.success) {
        this.evaluationOptions = res.result.map((item) => ({
          value: item.id,
          label: item.name,
        }))
        this.$set(this.queryParam, 'evaluationId', this.evaluationOptions[0].value)
        this.loadData()
      }
    },
    getTableData() {
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', true)
      const params = {
        planId: this.viewRecord.id,
        pageNo: this.tabPaneConfig[this.tabKey - 1].pagination.current,
        pageSize: this.tabPaneConfig[this.tabKey - 1].pagination.pageSize,
        ...this.queryParam,
      }
      getAction(this.url.list, params)
        .then((res) => {
          if (res.success) {
            const tableData = res.result.records.length
              ? res.result.records.map((item, index) => ({
                  ...item,
                  index: index + 1,
                }))
              : []
            this.$set(this.tabPaneConfig[this.tabKey - 1], 'tableData', tableData)
            this.$set(this.tabPaneConfig[this.tabKey - 1].pagination, 'total', res.result.total)
          }
        })
        .finally(() => {
          this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', false)
        })
    },
    async iknowAction(record) {
      if (record.knowStatus == 1) return
      const res = await putAction('/schoolEvaluationRecord/edit', {
        id: record.id,
        knowStatus: 1,
      })
      if (res?.success) {
        this.$message.success(res.message || '操作成功')
        this.loadData()
      } else {
        this.$message.error(res.message || '操作失败')
      }
    },
    addCommunicatRecord(record, type) {
      this.$refs.assessmentRecordRef.showModal(record, type)
    },
  },
}
</script>
<style scoped lang="less">
.query-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.action-detail {
  min-width: 100px !important;
  color: #1783e8 !important;
  cursor: pointer !important;
}
.search-space {
  width: 140px;
  margin-right: 15px;
}
</style>
